import { reportError } from "@/components/ErrorBoundary";

// Galeria que não abre (Pedro, 22/10/2026: «registre»). No Android 13+, o Chrome abre a galeria pelo seletor de fotos do
// próprio Android; quando esse seletor fecha na hora, o campo só recebe o evento `cancel` e o lojista toca em
// «Adicionar» sem nada acontecer (DG Burguer: nenhum rastro no servidor nem aqui). Ninguém abre e fecha a galeria em
// menos de 1,5 s, então o `cancel` que chega antes disso vira uma linha em client_errors, para sabermos quantas lojas
// passam por isso. Só registra: a tela não muda.
const LIMITE_MS = 1500;

function nomeDoCampo(input: HTMLInputElement): string {
  const rotulo = input.closest("label")?.textContent?.replace(/\s+/g, " ").trim();
  return (rotulo || input.getAttribute("aria-label") || "sem rótulo").slice(0, 40);
}

export function vigiarGaleriaQueNaoAbre() {
  if (typeof document === "undefined" || !/Android/i.test(navigator.userAgent)) return;
  let tocado: HTMLInputElement | null = null;
  let tocadoEm = 0;
  let escondeu = false;
  // O toque no rótulo também chega aqui: o navegador repassa o clique ao campo.
  document.addEventListener("click", (e) => {
    const el = e.target;
    if (!(el instanceof HTMLInputElement) || el.type !== "file") return;
    tocado = el;
    tocadoEm = performance.now();
    escondeu = false;
  }, true);
  // Vai junto no registro, sem filtrar: o seletor que abre e fecha na hora pode ou não esconder a página.
  document.addEventListener("visibilitychange", () => {
    if (document.visibilityState === "hidden") escondeu = true;
  });
  document.addEventListener("cancel", (e) => {
    const el = e.target;
    if (!(el instanceof HTMLInputElement) || el.type !== "file" || el !== tocado) return;
    const ms = Math.round(performance.now() - tocadoEm);
    tocado = null;
    if (ms >= LIMITE_MS) return;
    reportError(
      new Error(`campo=${nomeDoCampo(el)} ms=${ms} multiplo=${el.multiple ? 1 : 0} escondeu=${escondeu ? 1 : 0}`),
      null,
      "galeria-nao-abriu",
    );
  }, true);
}
